import { Button, Flex, Tag, Text } from '@chakra-ui/react';
import { IndigoLogoGradient } from '~/common/icons/IndigoLogoGradient';
import { useListingPageContext } from '../../ListingPageContext';

export const EnabledIndigoDataTag = () => {
  const { setIncludeIndigoData } = useListingPageContext();

  return (
    <Tag borderRadius="5px">
      <Flex alignItems="center" fontWeight="normal" gap={1}>
        <IndigoLogoGradient />
        <Button
          color="white"
          fontWeight="normal"
          size="sm"
          textDecoration="underline"
          variant="link"
          onClick={() => setIncludeIndigoData(true)}
        >
          Enhance
        </Button>
        <Text
          color="whiteAlpha.700"
          letterSpacing={0}
          textTransform="none"
          whiteSpace={{ base: 'nowrap', md: 'normal' }}
        >
          with real-time data from Indigo Offers
        </Text>
      </Flex>
    </Tag>
  );
};
